const CHUNK_RELOAD_AT_KEY = 'bcc-chunkReloadAt';
// Gives the user time to read the restart notification before the page goes away.
const RELOAD_DELAY_MS = 2000;
// After a deploy the old hashed chunks are deleted from the server, so a tab still running the old build fails on its next
// lazy route/component load. Webpack throws those (JS and CSS chunks alike) with name 'ChunkLoadError'.
// Reloading picks up the new index.html and its new chunk hashes. Guarded so a cached index.html can't reload-loop forever:
// a chunk failure within guardMs of the last auto-reload doesn't apply, and older timestamps just age out.
export function chunkReloadPolicy({ guardMs = 60 * 1000 } = {}) {
    return {
        appliesTo: (error) => {
            const isChunkLoadError = error.__error?.name === 'ChunkLoadError';
            const lastReloadAt = Number(sessionStorage.getItem(CHUNK_RELOAD_AT_KEY)) || 0;
            return isChunkLoadError && Date.now() - lastReloadAt > guardMs;
        },
        // The restart message below replaces the default error notification.
        skipNotify: () => true,
        postProcess: (_error, notify) => {
            sessionStorage.setItem(CHUNK_RELOAD_AT_KEY, String(Date.now()));
            notify({ message: 'A new version of the application is available, so the application needs to restart.', level: 'info' });
            setTimeout(() => window.location.reload(), RELOAD_DELAY_MS);
        },
    };
}
